module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAABS0lEQVRYCe3BsUtUcRwA8O+QGVR/QQSG5+BB5y4URn+BuAj+By0t7i5i0dLgIuEQODoKSUNDY3iS7y+4QYQHbzjoJhX56CEiz7tn7y5o+n0+kSRJkvwPpq3YsOtIR64v13Fk14YV0zEukxbtOPY3x3YsmoxRmLOtaxRd2+aiDgv2jWvfQtxHw567/vjmg2XzpjyJK56aMm/ZR9/13LWnEcOYsO5UWcdrD+IeHnrrRNmpdRNRZsaBQe2oQWbQgZm4ZUnPMO2oQWaYnqW4ZtWF4dpRg8xwF1Yjwppq7ahBptpa6KrWjhpkqnXDoWq/oga/VTsMs3JVPkcNtlQpvIwITblBZz55FDV4bNO5QYVWXNOUK/thNkag5aeyQituacrdOPMuxuC9czcKrSjTlOvLvYoxeaPQV2jFIC98selZ/APPbfmqEUmSJElScgkU7jYxGcRPJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sdks/agora/assets/icon-exit-hover.png
// module id = 437
// module chunks = 0